// extracted by mini-css-extract-plugin
export default {"chat-head":"chat-head--9hNsU","left":"left--Nnsaj","right":"right--2T2hQ","hidden":"hidden--kTTXE"};